import Head from "next/head";
import React from "react";
import { ExtendedNextPage } from "types/pages";
import HummingNav from "pages/components/HummingNav";
import HummingFooter from "pages/components/HummingFooter";
import VendorContact from "components/VendorContact";
import text from "constants/text";
import styles from "./styles.module.scss";
import Heading from "./components/Heading";
import HearFromOurProviders from "./components/HearFromOurProviders";
import GrowingOurVendorNetwork from "./components/GrowingOurVendorNetwork";
import ThePromise from "./components/ThePromise";
import HowItWorks from "./components/HowItWorks";
import TheHHDifference from "./components/TheHHDifference";
import WhereWeAre from "../homepage/components/WhereWeAre";

const Vendors: ExtendedNextPage = () => {
  const { heading } = text.vendors;

  return (
    <div className={styles.container}>
      <Head>
        <title>Become A Vendor | Humming Homes</title>
        <meta
          name="description"
          content="Becoming a vendor has never been easier with Humming Homes"
        />
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://humminghomes.com/pros" />
      </Head>
      <Heading {...heading} />
      <GrowingOurVendorNetwork />
      <TheHHDifference />
      <HearFromOurProviders />
      <HowItWorks />
      <WhereWeAre />
      <ThePromise />
      <VendorContact />
    </div>
  );
};

Vendors.getLayout = (page) => {
  return (
    <div>
      <HummingNav isVendorCta />
      {page}
      <HummingFooter />
    </div>
  );
};

export default Vendors;
